import React, { useRef, useState, useEffect } from "react";
import io from "socket.io-client";
import DepartmentDropdown from "./DepartmentDropdown";
import axios from "axios";
import "./Ticket2.css";
import { useNavigate } from "react-router-dom";
import { BsArrowLeft } from "react-icons/bs";
axios.defaults.withCredentials = true;

const EMAIL_REGEX = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi;

const extractValidEmails = (values) => {
  const set = new Set();
  (values || []).forEach((raw) => {
    if (!raw) return;
    const s = String(raw);
    s.split(/[,\s;]+/).forEach((piece) => {
      const hits = String(piece).match(EMAIL_REGEX);
      if (hits) hits.forEach((e) => set.add(e.toLowerCase()));
    });
    const hitsWhole = s.match(EMAIL_REGEX);
    if (hitsWhole) hitsWhole.forEach((e) => set.add(e.toLowerCase()));
  });
  return [...set];
};

const StatusBadge = ({ status }) => {
  const getStatusClass = () => {
    switch (status?.toLowerCase()) {
      case "open":
        return "status status-open";
      case "foundcause":
        return "status status-foundcause";
      case "closed":
        return "status status-closed";
      case "nextfollowup":
        return "status status-nextfollowup";
      default:
        return "status";
    }
  };
  return <span className={getStatusClass()}>{status}</span>;
};

const PriorityIndicator = ({ level }) => {
  const getPriorityClass = () => {
    switch (level?.toLowerCase()) {
      case "high":
        return "priority priority-high";
      case "critical":
        return "priority priority-critical";
      case "medium":
        return "priority priority-medium";
      case "low":
        return "priority priority-low";
      default:
        return "priority";
    }
  };
  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <span className={getPriorityClass()}></span>
      {level}
    </div>
  );
};

const TicketDetailAdmin2 = ({ ticket, formatDate }) => {
  const [alertMessage, setAlertMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [userEmail, setUserEmail] = useState("");
  const [ticketStatus, setTicketStatus] = useState(ticket.Status || "open");
  const [recipients, setRecipients] = useState("");
  const [responses, setResponses] = useState([]);
  const [socket, setSocket] = useState(null);
  const [, setTickets] = useState([]);
  const [subject, setSubject] = useState(ticket.Details || "");
  const [isUpdatingSubject, setIsUpdatingSubject] = useState(false);
  const [isEditingSubject, setIsEditingSubject] = useState(false);
  const [attachedFiles, setAttachedFiles] = useState([]);
  const [selectedRecipients, setSelectedRecipients] = useState([]);
  const [departmentData, setDepartmentData] = useState([]);
  const [newSeverity, setNewSeverity] = useState(
    ticket.SeverityLevels || "low"
  );
  const [isUpdatingSeverity, setIsUpdatingSeverity] = useState(false);
  const [lastUpdate, setLastUpdate] = useState(null);
  const [replyFiles, setReplyFiles] = useState([]);
  const fileInputRef = useRef(null);

  const [me, setMe] = useState(null);
  useEffect(() => {
    (async () => {
      try {
        const res = await axios.get("/authadmin/me", {
          withCredentials: true,
        });
        setMe(res.data.user || null);
      } catch {
        setMe(null);
      }
    })();
  }, []);
  const employeeId = me?.id || null;
  const navigate = useNavigate();
  const chatContainerRef = useRef(null);

  const createEmailTemplate = (recpient, messageData, senderName) => {
    const latestMsg = messageData.message;

    return `
        <!DOCTYPE html>
        <html>
        <head>
          <meta charset="UTF-8">
          <style>
            body { font-family: Arial, sans-serif; line-height: 1.6; color: #333; }
            .container { max-width: 600px; margin: 0 auto; padding: 20px; }
            .header { background-color: #007bff; color: white; padding: 20px; border-radius: 5px 5px 0 0; }
            .content { background-color: #f8f9fa; padding: 20px; border: 1px solid #dee2e6; }
            .footer { background-color: #6c757d; color: white; padding: 15px; text-align: center; border-radius: 0 0 5px 5px; }
            .message-box { background-color: white; padding: 15px; border-left: 4px solid #007bff; margin: 15px 0; }
            .btn { display: inline-block; padding: 10px 20px; background-color: #007bff; color: white; text-decoration: none; border-radius: 5px; }
            </style>
          </head>
          <body>
            <div class="container">
            <div class="header">
            <h2>🎫 Ticket #${ticket.id} (${ticket.FullName}/${
      ticket.IssueSummary
    })</h2>
          </div>
            
             <div class="content">
              <p><strong>ข้อความล่าสุด:</strong> ${latestMsg}</p>
              <h3>📋 รายละเอียด Ticket:</h3>
              <ul>
                <li><strong>หัวข้อ:</strong> ${ticket.IssueSummary}</li>
                <li><strong>รายละเอียด:</strong> ${ticket.Details}</li>
                <li><strong>สถานะปัจจุบัน:</strong> ${messageData.Status}</li>
                <li><strong>วันที่สร้าง:</strong> ${formatDate(
                  ticket.Date
                )}</li>
              </ul>
              </p> 
            </div>
          </div>
        </body>
        </html>
      `;
  };

  const sendEmailNotification = async (emails, messageData) => {
    const senderName = me?.email || "Admin";

    const uniqEmails = [
      ...new Set((emails || []).map((e) => (e || "").trim()).filter(Boolean)),
    ];
    if (uniqEmails.length === 0) return;

    const emailData = {
      to: uniqEmails,
      subject: `Ticket #${messageData.ticket_id} (${ticket.FullName}/${ticket.IssueSummary})`,
      html: createEmailTemplate(null, messageData, senderName),
    };
    try {
      await axios.post(
        "/ticketadmin/send-notification-email",
        emailData,
        {
          withCredentials: true,
        }
      );
    } catch (error) {
      console.error("❌ Failed to send email notifications:", error);
    }
  };

  const today = new Date().toISOString().split("T")[0];

  const [nextFollowupDate, setNextFollowupDate] = useState(
    ticket.next_followup_date ? ticket.next_followup_date.split("T")[0] : ""
  );

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (recipients.trim() === "") {
      setAlertMessage("⚠️ Please fill out all required fields.");
      return;
    }

    if (selectedRecipients.length === 0) {
      setAlertMessage("⚠️ Please select at least one recipient in 'Reply To'.");
      return;
    }

    if (ticketStatus === "nextfollowup") {
      if (!nextFollowupDate) {
        setAlertMessage("⚠️ Please choose a follow‑up date.");
        return;
      }
      if (nextFollowupDate < today) {
        setAlertMessage("⚠️ Follow-up date cannot be in the past.");
        return;
      }
    }

    setIsSubmitting(true);

    try {
      const isCustomerSelected = selectedRecipients.includes(
        String(ticket.customer_id)
      );

      const uploadedFileNames = [];
      if (replyFiles?.length) {
        for (const f of replyFiles) {
          const name = await uploadFileToServer(f);
          if (name) uploadedFileNames.push(name);
        }
      }

      const messageData = {
        ticket_id: ticket.id,
        customer_id: isCustomerSelected ? ticket.customer_id : null,
        Email_admin: employeeId,
        message: recipients || "No Message",
        AttachFiles: uploadedFileNames,
        Reply: selectedRecipients.length ? selectedRecipients.join(",") : null,
        Status: ticketStatus,
        NextFollowupDate:
          ticketStatus === "nextfollowup" ? nextFollowupDate : null,
      };

      if (socket?.connected) {
        socket.emit("sendMessage", messageData);
      } else {
        console.warn("Socket not connected; queueing only email.");
      }

      const rawTargets = [];

      if (isCustomerSelected && ticket.Email) {
        rawTargets.push(ticket.Email);
      }
      selectedRecipients.forEach((val) => {
        if (!val) return;
        rawTargets.push(val);

        const dept = departmentData.find((d) => String(d.id) === String(val));
        if (dept) {
          if (dept.email) rawTargets.push(dept.email);
          (dept.members || []).forEach(
            (m) => m?.email && rawTargets.push(m.email)
          );
        }
      });

      const emailTargets = extractValidEmails(rawTargets);
      if (emailTargets.length) {
        await sendEmailNotification(emailTargets, messageData);
      } else {
        console.warn("No valid email targets; skipped email sending.");
      }

      setReplyFiles([]);
      if (fileInputRef.current) fileInputRef.current.value = "";
      setRecipients("");
      setSelectedRecipients([]);

      setAlertMessage("✅ Ticket saved successfully and notifications sent!");
      setTimeout(() => setAlertMessage(""), 3000);
    } catch (error) {
      console.error("❌ Error saving ticket:", error.response?.data || error);
      setAlertMessage("❌ Failed to save ticket. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleDeleteFile = async (fileToDelete) => {
    const confirmDelete = window.confirm(
      `คุณต้องการยืนยันการลบไฟล์ "${fileToDelete}" ใช่หรือไม่?`
    );
    if (!confirmDelete) return;

    setIsSubmitting(true);
    try {
      const { data } = await axios.post(
        "/ticketadmin/removeAttachFile",
        {
          TicketNumber: ticket.id,
          fileToDelete,
        },
        {
          withCredentials: true,
        }
      );

      if (data.success) {
        setAttachedFiles(data.attachedFiles);
        setAlertMessage("✅ ไฟล์ถูกลบเรียบร้อยแล้วและรายการถูกอัปเดต!");
      } else {
        setAlertMessage(`❌ ลบไฟล์ไม่สำเร็จ: ${data.message}`);
      }
    } catch (err) {
      console.error("❌ Failed to delete file:", err);
      setAlertMessage("❌ ไม่สามารถลบไฟล์ได้ กรุณาลองใหม่อีกครั้ง");
    } finally {
      setTimeout(() => setAlertMessage(""), 3000);
      setIsSubmitting(false);
    }
  };

  const displayFormattedText = (text) => {
    if (!text) return null;
    return text.split("\n").map((line, index) => (
      <React.Fragment key={index}>
        {line}
        {index < text.split("\n").length - 1 && <br />}
      </React.Fragment>
    ));
  };

  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop =
        chatContainerRef.current.scrollHeight;
    }
  }, [responses]);

  useEffect(() => {
    if (Array.isArray(ticket.attachedFiles)) {
      setAttachedFiles(ticket.attachedFiles);
    } else {
      setAttachedFiles([]);
    }
  }, [ticket.attachedFiles]);

  useEffect(() => {
    const socketConnection = io("", {});
    setSocket(socketConnection);

    socketConnection.on("connect", () => {});
  }, []);

  useEffect(() => {
    if (!socket) return;

    const handleNewMessage = (messageData) => {
      setResponses((prev) => {
        const exists = prev.some((msg) => msg.id === messageData.id);
        return exists ? prev : [...prev, messageData];
      });
    };

    socket.on("ticketResponse", handleNewMessage);

    return () => {
      socket.off("ticketResponse", handleNewMessage);
    };
  }, [socket]);

  useEffect(() => {
    if (socket && ticket?.id) {
      socket.emit("joinTicket", { ticketNumber: ticket.id });

      return () => {
        socket.emit("leaveTicket", { ticketNumber: ticket.id });
      };
    }
  }, [socket, ticket?.id]);

  useEffect(() => {
    setUserEmail(me?.email || "");
  }, [me]);

  useEffect(() => {
    if (!ticket?.id) return;

    const controller = new AbortController();

    (async () => {
      try {
        await axios.get("/authadmin/me", {
          withCredentials: true,
          signal: controller.signal,
        });

        const res = await axios.get(
          "/ticketadmin/messageadmin",
          {
            params: { ticketNumber: ticket.id },
            withCredentials: true,
            validateStatus: (s) => s >= 200 && s < 500,
            signal: controller.signal,
          }
        );

        if (res.status === 404) {
          setResponses([]);
        } else {
          const list = Array.isArray(res.data) ? res.data : [];
          setResponses(list);
        }
      } catch (err) {
        if (axios.isCancel?.(err) || err?.name === "CanceledError") return;

        const status = err?.response?.status;

        if (status === 401) {
          navigate("/admin");
        } else if (status === 403) {
          alert("คุณไม่มีสิทธิ์เข้าถึง ticket นี้");
          navigate("/tickets");
        } else {
          console.error("Error fetching responses:", err);
        }
      }
    })();

    return () => controller.abort();
  }, [ticket?.id, navigate]);

  useEffect(() => {
    (async () => {
      try {
        const res = await axios.get("/ticketadmin", {
          withCredentials: true,
        });
        setTickets(res.data || []);
      } catch (e) {
        console.error("Fetch tickets failed:", e);
      }
    })();
  }, []);

  useEffect(() => {
    const fetchDepartmentsAndEmployees = async () => {
      try {
        const departmentsResponse = await axios.get(
          "/department",
          {
            withCredentials: true,
          }
        );
        const departments = departmentsResponse.data;

        const employeesResponse = await axios.get(
          "/employees",
          {
            withCredentials: true,
          }
        );
        const employees = employeesResponse.data;
        const combinedData = departments.map((dept) => ({
          id: dept.id,
          name: dept.name,
          email: dept.email || "",
          members: employees
            .filter((emp) => emp.department_id === dept.id)
            .map((emp) => ({
              name: emp.name,
              email: emp.email,
            })),
        }));

        setDepartmentData(combinedData);
      } catch (error) {
        console.error("Error fetching departments or employees:", error);
      }
    };

    fetchDepartmentsAndEmployees();
  }, []);

  useEffect(() => {
    const fetchLastUpdate = async () => {
      try {
        const res = await axios.get(
          `/ticketadmin/last-update`,
          {
            params: { ticketId: ticket.id },
            withCredentials: true,
            validateStatus: (s) => s >= 200 && s < 500,
          }
        );

        if (res.status === 404) {
          setLastUpdate(null);
        } else {
          setLastUpdate(res.data?.lastUpdate ?? null);
        }
      } catch (error) {
        console.error("Error fetching last update", error);
        setLastUpdate(null);
      }
    };

    if (ticket?.id) {
      fetchLastUpdate();
    }
  }, [ticket]);

  const uploadFileToServer = async (file) => {
    const formData = new FormData();
    formData.append("file", file);

    const res = await axios.post(
      "/ticketadmin/upload",
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return res.data.filename;
  };

  const handleAddFiles = (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;

    const max = 100 * 1024 * 1024;
    const tooBig = files.find((f) => f.size > max);
    if (tooBig) {
      alert(`ไฟล์ "${tooBig.name}" เกิน 100MB`);
      e.target.value = "";
      return;
    }

    setReplyFiles((prev) => {
      const key = (f) => `${f.name}__${f.size}`;
      const existing = new Set(prev.map(key));
      const merged = [...prev];
      for (const f of files) {
        if (!existing.has(key(f))) merged.push(f);
      }
      return merged;
    });

    e.target.value = "";
  };

  const handleRemoveReplyFile = (idx) => {
    setReplyFiles((prev) => prev.filter((_, i) => i !== idx));
  };
  return (
    <>
      <div className="ticket-details-container">
        <button
          onClick={() => navigate("/admin/tickets")}
          style={{
            background: "none",
            border: "none",
            padding: 0,
            margin: 0,
            cursor: "pointer",
            width: "auto",
            height: "auto",
            color: "black",
            marginLeft: "20px",
            marginTop: "20px",
          }}
        >
          <BsArrowLeft size={25} />
        </button>
        <div className="ticket-detail-inline">
          <p className="Ticketnum">Ticket #{ticket.id}</p>
          <h3>Report: {ticket.IssueSummary}</h3>
          <br />
          <div className="row">
            <p>
              <strong>Company:</strong> {ticket.CompanyName || "Not Specified"}
            </p>
            <p>
              <strong>Status:</strong> <StatusBadge status={ticket.Status} />
            </p>
          </div>
          <div className="row">
            <p>
              <strong>User:</strong> {ticket.FullName}
              {ticket.is_active === 0 && " (Disabled)"}
            </p>

            <p>
              <strong>Email:</strong> {ticket.Email}
            </p>
          </div>
          <div className="row">
            <p>
              <strong>Department:</strong> {ticket.Position || "Not Available"}
            </p>
            <p>
              <strong>Create Date :</strong> {formatDate(ticket.Date)}
            </p>
          </div>
          <div className="row">
            <p>
              <strong>Phone:</strong> {ticket.Phone}
            </p>
            <p>
              <strong>Address:</strong> {ticket.Address}
            </p>
          </div>
        </div>

        <div className="ticket-detail-inline">
          <div className="row">
            <p>
              <strong>Assigned To:</strong> {me?.email || "Not Assigned"}
            </p>
            <p>
              <strong>Help Topic:</strong> {ticket.HelpTopic}
            </p>
          </div>
          <div className="row">
            <p>
              <strong>SLA:</strong>
              {ticket.SLA || "Not Assigned"}
            </p>
            <p>
              <strong>Last Update:</strong>{" "}
              {lastUpdate ? formatDate(lastUpdate) : "ยังไม่มีการอัปเดต"}
            </p>
          </div>
          <br />
          <div
            style={{
              gap: "0.5rem",
            }}
          >
            <strong>Subject:</strong>
            {isEditingSubject ? (
              <>
                <input
                  type="text"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                  className="form-input"
                  style={{
                    flex: 1,
                    width: "450px",
                    padding: "4px 8px",
                  }}
                />
                <button
                  className="btn btn-primary"
                  style={{
                    height: "32px",
                    padding: "0 12px",
                    marginLeft: "5px",
                    marginRight: "5px",
                    whiteSpace: "nowrap",
                    background: "green",
                    color: "white",
                    border: "none",
                    borderRadius: "5px",
                    cursor: isUpdatingSubject ? "not-allowed" : "pointer",
                    transition: "background-color 0.2s ease",
                  }}
                  disabled={isUpdatingSubject}
                  onMouseEnter={(e) => {
                    if (!isUpdatingSubject)
                      e.target.style.backgroundColor = "#28a745";
                  }}
                  onMouseLeave={(e) => {
                    if (!isUpdatingSubject)
                      e.target.style.backgroundColor = "green";
                  }}
                  onMouseDown={(e) => {
                    if (!isUpdatingSubject)
                      e.target.style.backgroundColor = "#1e7e34";
                  }}
                  onMouseUp={(e) => {
                    if (!isUpdatingSubject)
                      e.target.style.backgroundColor = "#28a745";
                  }}
                  onClick={async () => {
                    setIsUpdatingSubject(true);
                    try {
                      await axios.post(
                        "/ticketadmin/updateSubject",
                        {
                          TicketNumber: ticket.id,
                          Subject: subject,
                        },
                        {
                          withCredentials: true,
                        }
                      );
                      ticket.Details = subject;
                      setIsEditingSubject(false);
                    } catch (error) {
                      console.error("Failed to update subject", error);
                    } finally {
                      setIsUpdatingSubject(false);
                    }
                  }}
                >
                  {isUpdatingSubject ? "Saving..." : "Save"}
                </button>

                <button
                  className="btn"
                  style={{
                    height: "32px",
                    padding: "0 12px",
                    marginTop: "10px",
                    borderRadius: "5px",
                    border: "none",
                    color: "white",
                    cursor: "pointer",
                    backgroundColor: "gray",
                  }}
                  onMouseEnter={(e) =>
                    (e.target.style.backgroundColor = "#5a5a5a")
                  }
                  onMouseLeave={(e) =>
                    (e.target.style.backgroundColor = "gray")
                  }
                  onMouseDown={(e) =>
                    (e.target.style.backgroundColor = "#3a3a3a")
                  }
                  onMouseUp={(e) =>
                    (e.target.style.backgroundColor = "#5a5a5a")
                  }
                  onClick={() => {
                    setIsEditingSubject(false);
                    setSubject(ticket.Details);
                  }}
                >
                  Cancel
                </button>
              </>
            ) : (
              <>
                <span style={{ marginRight: "10px" }}>{ticket.Details}</span>
                <button
                  className="btn btn-primary"
                  style={{
                    height: "32px",
                    padding: "4px 12px",
                    whiteSpace: "nowrap",
                  }}
                  onClick={() => setIsEditingSubject(true)}
                >
                  Edit
                </button>
              </>
            )}
          </div>
          <br />

          <div
            className="row"
            style={{
              display: "flex",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "1rem",
            }}
          >
            <div
              style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
            >
              <span style={{ fontWeight: "bold" }}>Priority (Current):</span>
              <PriorityIndicator level={ticket.SeverityLevels} />
            </div>
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
            <span style={{ fontWeight: "bold" }}>Change Priority:</span>
            <select
              value={newSeverity}
              onChange={(e) => setNewSeverity(e.target.value)}
              className="form-select"
              style={{
                minWidth: "70px",
                height: "32px",
                padding: "4px 8px",
              }}
            >
              <option value="low">Low</option>
              <option value="medium">Medium</option>
              <option value="high">High</option>
            </select>
            <button
              className="btn btn-primary"
              style={{
                height: "32px",
                padding: "4px 12px",
                whiteSpace: "nowrap",
              }}
              onClick={async () => {
                setIsUpdatingSeverity(true);
                try {
                  await axios.post(
                    "/ticketadmin/updateSeverity",
                    {
                      TicketNumber: ticket.id,
                      SeverityLevels: newSeverity,
                    },
                    {
                      withCredentials: true,
                    }
                  );

                  await new Promise((resolve) => setTimeout(resolve, 500));
                  ticket.SeverityLevels = newSeverity;
                } catch (error) {
                  console.error("Failed to update severity", error);
                } finally {
                  setIsUpdatingSeverity(false);
                }
              }}
              disabled={isUpdatingSeverity}
            >
              {isUpdatingSeverity ? "Updating..." : "Confirm"}
            </button>
          </div>
          <br />
          <div>
            <p>
              <strong>Files:</strong>
            </p>
            <ul className="attachments-list">
              {attachedFiles && attachedFiles.length > 0 ? (
                attachedFiles.map((file, index) => (
                  <li key={index} className="attachments-item">
                    <a
                      className="attachments-link"
                      href={`/fileuploads/${encodeURIComponent(
                        file
                      )}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ marginRight: 10 }}
                    >
                      {file}
                    </a>
                    <button
                      className="btn-delete-file"
                      onClick={() => handleDeleteFile(file)}
                    >
                      Delete
                    </button>
                  </li>
                ))
              ) : (
                <li className="attachments-item">ไม่มีไฟล์แนบ</li>
              )}
            </ul>
          </div>
        </div>

        <div className="ticket-detail-inline">
          <h3>Conversation</h3>
          <div
            className="chat-messages"
            ref={chatContainerRef}
            style={{
              maxHeight: "400px",
              overflowY: "auto",
              border: "1px solid #ddd",
              padding: "15px",
              marginTop: "15px",
              backgroundColor: "#ffffff",
              borderRadius: "8px",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            }}
          >
            {responses.map((response) => {
              const isAdmin = !!response.employee_id;

              return (
                <div
                  key={response.id}
                  style={{
                    display: "flex",
                    justifyContent: isAdmin ? "flex-end" : "flex-start",
                    marginBottom: "10px",
                  }}
                >
                  <div
                    style={{
                      backgroundColor: isAdmin ? "#e8f5e9" : "#f8f9fa",
                      borderRadius: "12px",
                      padding: "12px 16px",
                      maxWidth: "80%",
                      width: "80%",
                      minWidth: "80px",
                      boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                      wordBreak: "break-word",
                    }}
                  >
                    <div style={{ whiteSpace: "pre-wrap" }}>
                      {displayFormattedText(response.Message)}
                    </div>

                    {response.AttachFiles && (
                      <div style={{ marginTop: "8px" }}>
                        {Array.isArray(response.AttachFiles) ? (
                          <ul className="attachments-list">
                            {response.AttachFiles.map((f, i) => (
                              <li key={i} className="attachments-item">
                                <a
                                  className="attachments-link"
                                  href={`/fileuploads/${encodeURIComponent(
                                    f
                                  )}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  {f}
                                </a>
                              </li>
                            ))}
                          </ul>
                        ) : (
                          <a
                            href={`/fileuploads/${encodeURIComponent(
                              response.AttachFiles
                            )}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {response.AttachFiles}
                          </a>
                        )}
                      </div>
                    )}

                    <div
                      style={{
                        fontSize: "12px",
                        color: "#777",
                        textAlign: isAdmin ? "right" : "left",
                        borderTop: "1px solid #ccc",
                        paddingTop: "4px",
                      }}
                    >
                      <div>
                        {isAdmin
                          ? `👨‍💼 Admin: ${response.senderName || "Admin"}`
                          : `🙋‍♂️ Customer: ${ticket?.FullName || "Customer"}`}
                      </div>
                      <div>{formatDate(response.created_at)}</div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div className="ticket-detail-inline">
          <form onSubmit={handleSubmit}>
            <p className="Ticketnum">Ticket #{ticket.id}</p>
            <div className="row">
              <p>
                <strong>From:</strong> {userEmail}
              </p>
              <p>
                <strong>Recipients:</strong> {ticket.Email}
              </p>
            </div>
            <div className="flex">
              <label>
                <strong>Attach File:</strong>
              </label>
              <input
                ref={fileInputRef}
                type="file"
                multiple
                onChange={handleAddFiles}
                style={{
                  width: "50%",
                  padding: "6px",
                  borderRadius: "4px",
                  border: "1px solid #ccc",
                }}
              />
            </div>

            {replyFiles.length > 0 && (
              <ul className="attachments-list">
                {replyFiles.map((f, i) => (
                  <li key={i} className="attachments-item">
                    <span style={{ marginRight: 8 }}>
                      📎 {f.name} ({Math.ceil(f.size / 1024)} KB)
                    </span>
                    <button
                      type="button"
                      className="btn-remove-file"
                      onClick={() => handleRemoveReplyFile(i)}
                    >
                      Remove
                    </button>
                  </li>
                ))}
              </ul>
            )}

            <div className="row">
              <div className="form-group">
                <label>
                  <strong>Reply To:</strong>
                </label>
                <DepartmentDropdown
                  departments={departmentData}
                  selectedItems={selectedRecipients || []}
                  onChange={setSelectedRecipients}
                  userEmail={ticket.Email}
                  customerId={ticket.customer_id}
                />
              </div>
            </div>

            <div className="row">
              <div className="form-group">
                <label>
                  <strong>Additional Recipients:</strong>
                </label>
                <textarea
                  value={recipients}
                  onChange={(e) => setRecipients(e.target.value)}
                  placeholder="Please enter your message here...."
                  className="form-input"
                  style={{
                    height: "150px",
                    padding: "10px",
                    whiteSpace: "pre-wrap",
                    maxWidth: "100%",
                    width: "100%",
                  }}
                />
              </div>
            </div>
            <div className="row">
              <div className="form-group">
                <label>
                  <strong>Ticket Status:</strong>
                </label>
                <select
                  value={ticketStatus}
                  onChange={(e) => setTicketStatus(e.target.value)}
                  className="form-select"
                >
                  <option value="open">Open</option>
                  <option value="foundcause">Found cause</option>
                  <option value="nextfollowup">Next Followup</option>
                  <option value="closed">Closed</option>
                </select>
              </div>

              {ticketStatus === "nextfollowup" && (
                <div className="form-group" style={{ marginTop: "0.5rem" }}>
                  <label>
                    <strong>Follow‑up Date:</strong>
                  </label>
                  <input
                    type="date"
                    value={nextFollowupDate}
                    onChange={(e) => setNextFollowupDate(e.target.value)}
                    className="form-input"
                    style={{ width: "200px", padding: "4px 8px" }}
                    min={today}
                  />
                </div>
              )}
            </div>
            {alertMessage && <div className="alert">{alertMessage}</div>}
            <br />
            <div className="row">
              <button
                type="submit"
                className="btn-primary"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Saving..." : "Reply"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default TicketDetailAdmin2;
